<section class="h-full flex flex-col ">
  <app-modal-header title="Are you sure?" (onClose)="dialogRef.close()" [confirm]="true" (onConfirm)="confirm()"></app-modal-header>

  <mat-dialog-content>

    <div [ngSwitch]="data.section">
      <p class="mb-2" *ngSwitchCase="'workspace-stuff'">
        This action can affect other elements from your workspace.
      </p>
      <ng-container *ngSwitchCase="'change-auth-token'" class="mb-2">
        <p class="mb-2">
          <i class="fas fa-exclamation-triangle text-red-700"></i>
          Please be aware that this action will invalidate the existing token immediately.
        </p>
        <p class="mb-2">
          Any systems, applications, or integrations using the current token will need to be updated with the new token to
          continue accepting requests. Failure to update the token in all relevant places may result in rejected
          connections and a disruption in data transmission.
        </p>
        <p class="mb-2">
          Please ensure that you are ready to make this change and have access to all necessary areas to update the token
          promptly.
        </p>
      </ng-container>
      <p class="mb-2" *ngSwitchCase="'delete-computations-group'">
        You will also delete all computations in this group.
      </p>
      <p class="mb-2" *ngSwitchCase="'delete-track-record'">
        You are about to delete this record. Its tracked activity is kept, but stops being
        attributed to anyone.
      </p>
      <p class="mb-2" *ngSwitchCase="'delete-meeting'">
        You are about to delete this meeting. It stops counting on the contact's timeline and in the dashboards.
      </p>
      <p class="mb-2" *ngSwitchCase="'cancel-notetaker'">
        You are about to cancel this meeting's notetaker.
      </p>
      <p class="mb-2" *ngSwitchCase="'delete-track-event'">
        You are about to delete this activity. It stops counting on the record and in the dashboards.
      </p>
      <p class="mb-2" *ngSwitchCase="'delete-workflow'">
        You are about to delete this workflow and all its related data.
      </p>
      <p class="mb-2" *ngSwitchCase="'delete-extraction'">
        You are about to delete this data extraction and all its related data.
      </p>
      <p class="mb-2" *ngSwitchCase="'stop-extraction'">
        You are about to interrupt this data extraction execution. Stopping can take a few minutes to be effective.
      </p>
      <p class="mb-2" *ngSwitchCase="'run-extraction'">
        Current workflow state and data will be saved and the extraction will run immediately.
      </p>
      <p class="mb-2" *ngSwitchCase="'clear-extraction-memory'">
        You are about to wipe the tracked history for this extraction. On its next run, every item
        will be treated as new — previously processed items may be sent to the workflow again.
        This cannot be undone.
      </p>

      <p class="mb-2" *ngSwitchCase="'delete-crm-filter'">
        This saved filter disappears for everyone in the workspace. The records it matched are
        untouched — it is the saved question that goes, not the answer.
      </p>

      <p class="mb-2" *ngSwitchCase="'delete-crm-segment'">
        This segment disappears for everyone in the workspace. The records it matched are untouched.
      </p>

      <p class="mb-2" *ngSwitchCase="'update-crm-segment'">
        Everything that reads this segment acts on its new members from its next run.
      </p>

      <p class="mb-2" *ngSwitchCase="'delete-crm-attribute'">
        This deletes the attribute and erases its value from every record. It can't be undone.
      </p>

      <p class="mb-2" *ngSwitchCase="'delete-icp'">
        You are about to delete this ICP definition. Anything already scored against it keeps its
        result, but nothing new can reference it. Archive it instead if you only want it out of the way.
      </p>

      <p class="mb-2" *ngSwitchCase="'regenerate-icp'">
        We will reopen the interview with what you told us last time. Rebuilding from it overwrites
        every field below, including any corrections you made by hand — until you rebuild, nothing changes.
      </p>

      <p class="mb-2" *ngSwitchCase="'delete-voice'">
        You are about to delete this voice. Messages already generated with it are not affected.
      </p>

      <p class="mb-2" *ngSwitchCase="'regenerate-voice'">
        We will reopen the interview with what you told us last time. Rebuilding overwrites every field,
        including any corrections you made by hand — until you rebuild, nothing changes.
      </p>

      <p class="mb-2" *ngSwitchCase="'mass-replay'">
        You are about to re-trigger every run matching your filter. Each replay consumes credits and
        may write again to your connected integrations.
      </p>

      <p class="mb-2" *ngSwitchCase="'delete-event-type'">
        Every booking link for this event type stops working immediately, and anyone who already has
        one will see that it is no longer active. Meetings already booked stay on the calendar.
      </p>

      <p class="mb-2" *ngSwitchCase="'delete-schedule'">
        Event types using these hours will have no availability until you point them at another
        schedule — their booking pages will show no times.
      </p>

      <p class="mb-2" *ngSwitchCase="'revoke-booking-link'">
        The URL stops working immediately and cannot be un-revoked. Anyone who still has it — in an
        email, a sequence, a signature — will see that the link is no longer active. Meetings already
        booked through it are unaffected, and keep their attribution.
      </p>

      <p class="mb-2" *ngSwitchCase="'delete-assistant-thread'">
        The conversation and its messages are deleted. Anything the assistant already learned from
        it stays in its memory — remove that from the Memory tab.
      </p>
      <p class="mb-2" *ngSwitchCase="'delete-assistant-memory'">
        The assistant stops using this in future conversations.
      </p>

      <p class="mb-2" *ngSwitchDefault>
        Please confirm your action.
      </p>

    </div>

    <p class="mb-2" *ngIf="data.detail">{{data.detail}}</p>

    <mat-slide-toggle *ngIf="data.toggle" class="mb-2" color="primary" [(ngModel)]="toggled">{{data.toggle}}</mat-slide-toggle>

    <div *ngIf="data.extraConfirmation">
      <p class="mb-2">
        As a safety measure, please write <code>DELETE</code> in the box below:
      </p>
      <div class="dm-input mt-2">
        <label for="">Confirmation</label>
        <input type="text" placeholder="DELETE" [(ngModel)]="input">
      </div>
    </div>


  </mat-dialog-content>
</section>
